import { createContext, useContext, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import usePermission from '../hooks/usePermission';

export const PermissionContext = createContext();

export default function PermissionProvider({ children }) {
    const { permission, getUserPermission } = usePermission();

    useEffect(() => {
        getUserPermission();
    }, [getUserPermission]);

    const values = useMemo(
        () => ({
            permission: permission?.permissionDetail
                ? JSON.parse(permission?.permissionDetail)
                : [],
        }),
        [permission?.permissionDetail]
    );

    return (
        <PermissionContext.Provider value={values}>
            {children}
        </PermissionContext.Provider>
    );
}

// Props
PermissionProvider.propTypes = {
    children: PropTypes.node.isRequired,
};

export const usePermissionContext = () => useContext(PermissionContext);
